"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultTheme = void 0;
const react_ui_1 = require("@yanzi/react-ui");
function useDefaultTheme(defaultTheme) {
    var _a, _b;
    const hostname = window.location.hostname;
    return ((_b = (_a = themeConfig.find(({ patterns }) => patterns.some(pattern => hostname.match(pattern)))) === null || _a === void 0 ? void 0 : _a.theme) !== null && _b !== void 0 ? _b : defaultTheme);
}
exports.useDefaultTheme = useDefaultTheme;
const themeConfig = [
    {
        patterns: [/schneider/],
        theme: react_ui_1.ThemeName.schneider,
    },
    {
        patterns: [/telia/],
        theme: react_ui_1.ThemeName.barbie,
    },
    {
        patterns: [/humly/],
        theme: react_ui_1.ThemeName.humly,
    },
    {
        patterns: [/nordomatic/],
        theme: react_ui_1.ThemeName.nordomatic,
    },
];
//# sourceMappingURL=useDefaultTheme.js.map